/*jshint esversion: 9 */

export const FlexBarMixin = {
  data: () => ({
    getStatisticsHeightVariables: {
      statistics_height: 300,
    },
    statistic_mouse_down: false,
  }),
  computed: {
    isStatisticsVisible() {
      if (this.statistic_mouse_down || (this.$refs.statistics_background_blurr && this.$refs.statistics_background_blurr.$el.style.height !== '0px')) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    flexBarHeightMouseDown(payload) {
      this.statistic_mouse_down = true;
      this.getStatisticsHeightVariables = Object.assign(this.getStatisticsHeightVariables, {
        initial_y: payload.evt.pageY,
        initial_height: this.$refs.statistics_background_blurr.$el.clientHeight,
        set_statistics_height: true,
      });
      this.$refs.header_row_statistics.$el.style.transitionDuration = '0ms';
      this.$refs.statistics_background_blurr.$el.style.transitionDuration = '0ms';
      document.getElementById('statistics-activator').style.transitionDuration = '0ms';
      if (this.$refs.filter) {
        this.$refs.filter.closeFilter();
      }
      if (this.$refs.statisticSettings) {
        this.$refs.statisticSettings.closeFilter();
      }
      if (this.$refs.statisticSettingsCumulative) {
        this.$refs.statisticSettingsCumulative.closeFilter();
      }
    },
    flexBarHeightMouseUp() {
      this.statistic_mouse_down = false;
      if (this.getStatisticsHeightVariables.set_statistics_height) {
        this.$refs.header_row_statistics.$el.style.transitionDuration = '300ms';
        this.$refs.statistics_background_blurr.$el.style.transitionDuration = '300ms';
        document.getElementById('statistics-activator').style.transitionDuration = '300ms';
        //when just clicked
        if (this.$refs.statistics_background_blurr.$el.clientHeight === this.getStatisticsHeightVariables.initial_height) {
          if (this.$refs.statistics_background_blurr.$el.clientHeight === 0) {
            this.getStatisticsHeightVariables.set_statistics_height = false;
            this.$refs.header_row_statistics.$el.style.height = `${this.getStatisticsHeightVariables.statistics_height}px`;
            this.$refs.statistics_background_blurr.$el.style.height = `${this.getStatisticsHeightVariables.statistics_height}px`;
            document.getElementById('statistics-activator').style.top = `${this.getStatisticsHeightVariables.statistics_height + 53}px`;

          } else {
            this.getStatisticsHeightVariables.set_statistics_height = false;
            this.$refs.header_row_statistics.$el.style.height = `0px`;
            this.$refs.statistics_background_blurr.$el.style.height = `0px`;
            document.getElementById('statistics-activator').style.top = `53px`;
          }
        }
        // when resized
        else {
        this.getStatisticsHeightVariables = Object.assign(this.getStatisticsHeightVariables, {set_statistics_height: false, statistics_height: this.$refs.statistics_background_blurr.$el.clientHeight});
        document.body.style.setProperty('--statistics_height', `${this.$refs.statistics_background_blurr.$el.clientHeight}px`);
        }
      }
    },
    flexBarHeightMouseMove(evt) {
      if (this.getStatisticsHeightVariables.set_statistics_height) {
        let difference_y = evt.pageY - this.getStatisticsHeightVariables.initial_y;
        this.$refs.header_row_statistics.$el.style.height = `${this.getStatisticsHeightVariables.initial_height + difference_y}px`;
        this.$refs.statistics_background_blurr.$el.style.height = `${this.getStatisticsHeightVariables.initial_height + difference_y}px`;
        document.getElementById('statistics-activator').style.top = `${this.getStatisticsHeightVariables.initial_height + difference_y + 53}px`;
      }
    },
  }
};
